import React from 'react';
import {
  Navigate,
  Routes,
  Route,
  useParams,
  useLocation,
} from 'react-router-dom';
import { isInternational as getIsInternational } from 'lib/helpers';
import { ReportPage } from 'components/ReportPage/ReportPage';
import Auth from 'containers/Auth';
import { useReport } from 'api/report/useReport';
import useToken from 'utils/useToken';
import NotFound from 'routes/pages/NotFound';
import { AuthenticatedView } from '../ReportsOverview/AuthenticatedView';
import { useInternational } from '../../providers/InternationalProvider';
import { PATHS } from '../../constants';

type ParamsType = { reportId: string };

const ReportContainer: React.FC = () => {
  const location = useLocation();
  const { accountName, displayStatus, contactCompanyForReport } =
    location?.state || {};
  const storedInternational = useInternational();
  const international = getIsInternational() || storedInternational;
  const { reportId } = useParams() as ParamsType;
  const token = useToken();
  const { report, isLoading, isError } = useReport({
    id: reportId,
    token,
    contactCompanyForReport,
  });

  if (isError)
    return <Navigate to={international ? PATHS.INTERNATIONAL : '/'} />;

  return (
    <Auth token={token} isLoading={isLoading}>
      <AuthenticatedView>
        <Routes>
          <Route
            path='/'
            element={
              <ReportPage
                report={
                  report || {
                    account: { name: accountName },
                    brandingName: '',
                    displayStatus,
                    id: reportId,
                    candidate: { email: '' },
                    countyCriminalSearches: [],
                  }
                }
                international={international}
                isLoading={isLoading}
                contactCompanyForReport={contactCompanyForReport}
              />
            }
          />
          <Route path='*' element={<NotFound />} />
        </Routes>
      </AuthenticatedView>
    </Auth>
  );
};

export default ReportContainer;
